import PaymentChartWidget from './components/widgets/PaymentChartWidget.vue';

import LiabilityWidget from './components/widgets/LiabilityWidget.vue';
import LiabilityChartWidget from './components/widgets/LiabilityChartWidget.vue';
import TotalCostSpanWidget from './components/widgets/TotalCostSpanWidget.vue';
import TotalPaymentChartWidget from "@/plugins/paymentCalculations/components/widgets/TotalPaymentChartWidget.vue";
import TotalLiabilityChartWidget from "@/plugins/paymentCalculations/components/widgets/TotalLiabilityChartWidget.vue";

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    Vue.component('payment-chart-widget', PaymentChartWidget);
    Vue.component('total-payment-chart-widget', TotalPaymentChartWidget);
    Vue.component('liability-widget', LiabilityWidget);
    Vue.component('liability-chart-widget', LiabilityChartWidget);
    Vue.component('total-liability-chart-widget', TotalLiabilityChartWidget);
    Vue.component('total-cost-span-widget', TotalCostSpanWidget);
  },
};
